module.exports = __webpack_public_path__ + "static/img/image-4.2419b535.jpg";